import React from "react";
import PropTypes from "prop-types";
import {APanelBody, APopover} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";

const RunInvestigationPopover = ({open, setOpen, anchorRef}) => {
  return (
    <APopover
      data-testid={"RunInvestigationPopover-Popover"}
      anchorRef={anchorRef}
      open={open}
      placement="right-top"
      onClose={() => setOpen(false)}>
      <APanelBody>
        <p>{t("investigate.runInvestigation.popoverContent.p")}</p>
        <ul>
          {t("investigate.runInvestigation.popoverContent.list", {
            returnObjects: true
          }).map((a, i) => (
            <li key={i}>{a}</li>
          ))}
        </ul>
      </APanelBody>
    </APopover>
  );
};

RunInvestigationPopover.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  anchorRef: PropTypes.object.isRequired
};

export default RunInvestigationPopover;
